import { omit, flow, keyBy, map, cloneDeep } from 'lodash/fp';

export function allIds(state, action) {
  const { items, deletedItemIds } = action.payload;

  // remove any deleted items
  const filteredState = state.filter(itemId => deletedItemIds.indexOf(itemId) < 0);

  // find the items that were added
  const newItemIds = items.filter(item => state.indexOf(item.itemId) === -1).map(i => i.itemId);

  return [...filteredState, ...newItemIds];
}

export function byId(state, action) {
  const { items, deletedItemIds } = action.payload;
  const newState = omit(deletedItemIds, state);

  const newItems = flow(
    map(cloneDeep),
    keyBy('itemId'),
  )(items);

  return { ...newState, ...newItems };
}
